/* =========================================================================
   Phrase Studios -- "The Circle" email-capture popup (2026-06-21, v5)
   Offer: Join The Circle -> 10% off your first order (code PHRASE10,
   the same code the live Welcome Series already emails, so popup + email match).
   Auto-opens after 5s (or 35% scroll / exit-intent). No teaser pill.
   No em dashes in copy (brand rule). Wired to Klaviyo client subscribe API:
   subscribes to the Email List (VksCP3) -> triggers the live Welcome Series.
   Split layout: brand hero photo (home_hero_friends_flowers) + offer.
   Copy uses HTML entities (&#39; &middot;) so the source stays pure ASCII.

   2026-09-08 (v6), consent gate. Shopify's cookie banner renders at
   z-index 2000000 against this box at 9000. On mobile the banner covered the
   whole offer: measured on a 390x844 viewport, elementFromPoint() over the
   email field returned the banner's button row, not the input, so the field
   could not be tapped at all and the only reachable control was the close
   button (which snoozes for 30 days). Mobile is 68% of sessions. The box now
   waits for the consent dialog to be resolved before it opens, and opens as
   soon as it is. Nothing else about the trigger logic changed.

   2026-10-06 (v7), centred modal. The corner card (desktop) and bottom sheet
   (mobile) read as a toast that people scrolled past. The offer now opens as
   a centred dialog over a dimmed backdrop on every screen size, with the
   email field in the middle of the screen. Closes on the X, "No thanks",
   a backdrop click or Esc (all snooze 30 days). Page scroll is locked while
   it is open, focus stays inside it, and on touch screens the field is not
   auto-focused so the keyboard does not jump up uninvited. Input is 16px so
   iOS does not zoom on focus. Snoozes are kept under a new key so visitors
   who closed the old card (on mobile often because they could not reach the
   field) see the new dialog once; a recorded subscribe under the old key
   still suppresses it for good. Triggers and consent gate unchanged.

   2026-10-06 (v8), Journal variant. On article pages (/blogs/<blog>/<handle>,
   EN and /nl/) the same dialog carries reader copy ("Like what you read?
   You'll like what you wear.") and arms after 8s (Sam: "about 5 to 10
   seconds"), 45% scroll or exit intent, whichever comes first.
   Same offer, same code, same list; custom_source 'Circle popup (journal)'
   tells the two apart in Klaviyo. The Journal index and tagged pages keep
   the site copy. Snooze and subscribe state are shared: one person, one offer.
   ========================================================================= */
(function () {
  'use strict';

  var COMPANY_ID = 'TDuvHK';
  var LIST_ID = 'VksCP3';
  var KEY = 'phrase_circle_popup_v7';
  var OLD_KEY = 'phrase_circle_popup_v3';
  var CODE = 'PHRASE10';
  var SNOOZE_DAYS = 30;
  var IMG = 'https://cdn.shopify.com/s/files/1/0583/5269/7552/files/home_hero_friends_flowers.jpg?width=900';

  var path = location.pathname.toLowerCase();
  var JOURNAL = /\/blogs\/[^\/]+\/[^\/]+/.test(path) && path.indexOf('/tagged/') === -1;
  var SHOW_AFTER_MS = JOURNAL ? 8000 : 5000;
  var SHOW_AFTER_SCROLL = JOURNAL ? 0.45 : 0.35;
  var SOURCE = JOURNAL ? 'Circle popup (journal)' : 'Circle popup (site)';
  var COPY = JOURNAL ? {
    badge: 'Journal readers &middot; 10% off',
    h: 'Like what you read? <em>You&#39;ll like what you wear.</em>'
  } : {
    badge: 'The Circle &middot; Welcome offer',
    h: '<em>10% off</em> your first order.'
  };
  if (path.indexOf('/checkout') === 0 || path.indexOf('/cart') === 0) return;
  try {
    var old = localStorage.getItem(OLD_KEY);
    if (old) { var so = JSON.parse(old); if (so && so.subscribed) return; }
    var raw = localStorage.getItem(KEY);
    if (raw) {
      var st = JSON.parse(raw);
      if (st && st.subscribed) return;
      if (st && st.snoozedUntil && Date.now() < st.snoozedUntil) return;
    }
  } catch (e) {}

  function save(obj) { try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch (e) {} }
  function snooze() { save({ snoozedUntil: Date.now() + SNOOZE_DAYS * 864e5 }); }
  function markSubscribed() { save({ subscribed: true }); }

  /* True only while a consent dialog is actually painted on screen.
     Deliberately measured from the DOM rather than asked of
     Shopify.customerPrivacy.shouldShowBanner(): that call keeps returning true
     until a choice is recorded, so gating on it would hold this box shut
     forever on any store or region where no banner ever renders. What matters
     here is whether something is physically covering the offer, which is what
     the measurement answers. No node, or a node with no painted box, is clear. */
  function consentBannerVisible() {
    var els = document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') < 0.05) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return true;
    }
    return false;
  }

  var css = [
  '.pcircle-ov{position:fixed;top:0;right:0;bottom:0;left:0;z-index:9000;display:flex;align-items:center;justify-content:center;',
  'padding:24px;box-sizing:border-box;background:rgba(11,11,10,.55);',
  'opacity:0;visibility:hidden;pointer-events:none;transition:opacity .3s cubic-bezier(.16,1,.3,1),visibility 0s linear .3s;}',
  '.pcircle-ov.is-open{opacity:1;visibility:visible;pointer-events:auto;transition:opacity .3s cubic-bezier(.16,1,.3,1),visibility 0s;}',
  '.pcircle{position:relative;width:760px;max-width:100%;max-height:100%;overflow:auto;-webkit-overflow-scrolling:touch;',
  'background:var(--phrase-surface,#fff);color:var(--phrase-ink,#0B0B0A);',
  'font-family:var(--phrase-font-body,"Inter Tight",system-ui,sans-serif);',
  'border-radius:16px;box-shadow:0 30px 80px rgba(11,11,10,.35);',
  'transform:translateY(14px) scale(.98);transition:transform .34s cubic-bezier(.16,1,.3,1);}',
  '.pcircle-ov.is-open .pcircle{transform:none;}',
  '.pcircle:focus{outline:none;}',
  '.pcircle__row{display:flex;align-items:stretch;}',
  '.pcircle__row .pcircle__media{display:block;flex:0 0 330px;background:#e9e7e2 url(' + IMG + ') center 18% / cover no-repeat;min-height:440px;}',
  '.pcircle__in{flex:1 1 auto;min-width:0;padding:44px 40px 34px;display:flex;flex-direction:column;justify-content:center;}',
  '.pcircle__badge{align-self:flex-start;display:inline-block;font-size:10px;font-weight:600;letter-spacing:.16em;text-transform:uppercase;',
  'color:var(--phrase-green,#2D4A15);border:1px solid var(--phrase-green,#2D4A15);border-radius:999px;padding:3px 9px;margin-bottom:16px;}',
  '.pcircle__h{margin:0 0 10px;font-size:30px;line-height:1.08;font-weight:700;letter-spacing:-.015em;}',
  '.pcircle__h em{font-style:normal;color:var(--phrase-green,#2D4A15);}',
  '.pcircle__p{margin:0 0 20px;font-size:14.5px;line-height:1.5;color:var(--phrase-ink-soft,#5b5b58);}',
  '.pcircle__form{display:flex;flex-direction:column;gap:10px;}',
  '.pcircle__input{width:100%;height:50px;padding:0 14px;border:1px solid var(--phrase-ink,#0B0B0A);',
  'border-radius:0;font:inherit;font-size:16px;background:#fff;color:var(--phrase-ink,#0B0B0A);box-sizing:border-box;-webkit-appearance:none;appearance:none;}',
  '.pcircle__input:focus{outline:2px solid var(--phrase-green,#2D4A15);outline-offset:-2px;}',
  '.pcircle__btn{height:50px;border:0;border-radius:999px;background:var(--phrase-green,#2D4A15);color:#fff;',
  'font:inherit;font-size:15px;font-weight:600;letter-spacing:.02em;cursor:pointer;transition:opacity .2s;}',
  '.pcircle__btn:hover{opacity:.9;}.pcircle__btn:disabled{opacity:.6;cursor:default;}',
  '.pcircle__no{display:block;margin:10px auto 0;padding:6px 10px;border:0;background:none;font:inherit;font-size:13px;',
  'color:var(--phrase-ink-soft,#5b5b58);cursor:pointer;}',
  '.pcircle__no:hover{color:var(--phrase-ink,#0B0B0A);}',
  '.pcircle__fine{margin:8px 0 0;font-size:11px;line-height:1.4;text-align:center;color:var(--phrase-ink-mute,#9a9a96);}',
  '.pcircle__err{margin:2px 0 0;font-size:12px;color:#B42318;display:none;}.pcircle__err.is-on{display:block;}',
  '.pcircle__code{align-self:flex-start;display:inline-block;margin:2px 0 18px;padding:10px 18px;border:1px dashed var(--phrase-green,#2D4A15);',
  'border-radius:10px;font-weight:700;font-size:18px;letter-spacing:.12em;color:var(--phrase-green,#2D4A15);background:none;font-family:inherit;cursor:pointer;}',
  '.pcircle__copied{margin:-10px 0 16px;font-size:12px;color:var(--phrase-green,#2D4A15);visibility:hidden;}.pcircle__copied.is-on{visibility:visible;}',
  '.pcircle__close{position:absolute;top:12px;right:12px;width:38px;height:38px;border:0;background:rgba(255,255,255,.85);',
  'cursor:pointer;color:var(--phrase-ink,#0B0B0A);font-size:22px;line-height:1;border-radius:999px;z-index:1;}',
  '.pcircle__close:hover{background:#fff;}',
  '.pcircle__ok{display:none;}.pcircle.is-done .pcircle__offer{display:none;}',
  '.pcircle.is-done .pcircle__ok{display:flex;flex-direction:column;}',
  'html.pcircle-lock,html.pcircle-lock body{overflow:hidden !important;}',
  '@media (max-width:640px){',
  '.pcircle-ov{padding:16px;}',
  '.pcircle{width:420px;border-radius:14px;}',
  '.pcircle__row{flex-direction:column;}',
  '.pcircle__row .pcircle__media{flex:none;width:100%;height:170px;min-height:0;background-position:center 22%;}',
  '.pcircle__in{padding:22px 20px 18px;}',
  '.pcircle__h{font-size:25px;}',
  '.pcircle__p{font-size:14px;margin-bottom:16px;}}',
  '@media (max-width:640px) and (max-height:640px){.pcircle__row .pcircle__media{height:110px;}}',
  '@media (max-height:520px){.pcircle__row .pcircle__media{display:none;}}',
  '@media (prefers-reduced-motion:reduce){.pcircle-ov,.pcircle-ov.is-open,.pcircle{transition:none;}.pcircle{transform:none;}}'
  ].join('');

  var BOX_HTML = [
  '<div class="pcircle" role="dialog" aria-modal="true" aria-labelledby="pcircle-h" tabindex="-1">',
  '<button class="pcircle__close" type="button" aria-label="Close">&times;</button>',
  '<div class="pcircle__row">',
  '<div class="pcircle__media" role="img" aria-label="Phrase Studios, The Circle"></div>',
  '<div class="pcircle__in">',
  '<div class="pcircle__offer">',
  '<span class="pcircle__badge">' + COPY.badge + '</span>',
  '<h2 class="pcircle__h" id="pcircle-h">' + COPY.h + '</h2>',
  '<p class="pcircle__p">Join The Circle and we&#39;ll take 10% off your first order, plus early access to every chapter drop before it&#39;s public.</p>',
  '<form class="pcircle__form" novalidate>',
  '<input class="pcircle__input" type="email" inputmode="email" autocomplete="email" placeholder="Email address" aria-label="Email address" required>',
  '<p class="pcircle__err" role="alert">That email didn&#39;t go through. Try again?</p>',
  '<button class="pcircle__btn" type="submit">Get my 10% off</button>',
  '</form>',
  '<p class="pcircle__fine">Free to join. Circle-only drops; unsubscribe anytime.</p>',
  '<button class="pcircle__no" type="button">No thanks</button>',
  '</div>',
  '<div class="pcircle__ok">',
  '<h2 class="pcircle__h">You&#39;re in The Circle.</h2>',
  '<p class="pcircle__p">Here&#39;s 10% off your first order, also sent to your inbox. Use it at checkout:</p>',
  '<button class="pcircle__code" type="button" aria-label="Copy code ' + CODE + '">' + CODE + '</button>',
  '<p class="pcircle__copied" aria-live="polite">Copied.</p>',
  '<button class="pcircle__btn pcircle__go" type="button">Keep browsing</button>',
  '</div>',
  '</div></div></div>'
  ].join('');

  function mount() {
    if (document.querySelector('.pcircle-ov')) return;
    var style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);

    var ov = document.createElement('div');
    ov.className = 'pcircle-ov';
    ov.setAttribute('data-lenis-prevent', '');
    ov.innerHTML = BOX_HTML;
    document.body.appendChild(ov);
    var box = ov.querySelector('.pcircle');
    var lastFocus = null;
    var isOpen = false;

    function lockScroll(on) {
      document.documentElement.classList.toggle('pcircle-lock', on);
      var l = window.lenis;
      if (l) { try { if (on && l.stop) l.stop(); else if (!on && l.start) l.start(); } catch (e) {} }
    }

    function focusables() {
      return Array.prototype.filter.call(
        box.querySelectorAll('button, input, [href], [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; });
    }

    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeBox(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function openBox() {
      isOpen = true;
      lastFocus = document.activeElement;
      ov.classList.add('is-open');
      lockScroll(true);
      document.addEventListener('keydown', onKey, true);
      /* Desktop: straight into the field. Touch: focus the dialog itself so
         the keyboard only comes up when the visitor taps the field. */
      var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;
      setTimeout(function () {
        var i = box.querySelector('.pcircle__input');
        try { if (fine && i) i.focus({ preventScroll: true }); else box.focus({ preventScroll: true }); } catch (e) {}
      }, 320);
    }
    function closeBox() {
      if (!isOpen) return;
      isOpen = false;
      ov.classList.remove('is-open');
      lockScroll(false);
      document.removeEventListener('keydown', onKey, true);
      if (!box.classList.contains('is-done')) snooze();
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }

    box.querySelector('.pcircle__close').addEventListener('click', closeBox);
    box.querySelector('.pcircle__no').addEventListener('click', closeBox);
    box.querySelector('.pcircle__go').addEventListener('click', closeBox);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeBox(); });

    box.querySelector('.pcircle__code').addEventListener('click', function () {
      var done = box.querySelector('.pcircle__copied');
      function shown() { done.classList.add('is-on'); }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(shown, function () {});
      } catch (e) {}
    });

    box.querySelector('.pcircle__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = box.querySelector('.pcircle__input');
      var btn = box.querySelector('.pcircle__form .pcircle__btn');
      var err = box.querySelector('.pcircle__err');
      var email = (input.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { err.classList.add('is-on'); input.focus(); return; }
      err.classList.remove('is-on'); btn.disabled = true; btn.textContent = 'Joining...';

      var payload = { data: { type: 'subscription', attributes: {
        custom_source: SOURCE,
        profile: { data: { type: 'profile', attributes: { email: email } } }
      }, relationships: { list: { data: { type: 'list', id: LIST_ID } } } } };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (r.status === 202 || r.ok) {
          markSubscribed(); box.classList.add('is-done');
          try { box.querySelector('.pcircle__go').focus({ preventScroll: true }); } catch (e) {}
          if (window.klaviyo && window.klaviyo.identify) { try { window.klaviyo.identify({ email: email }); } catch (e) {} }
        } else { throw new Error('status ' + r.status); }
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Get my 10% off'; err.classList.add('is-on');
      });
    });

    /* Open only onto a clear screen. While the consent dialog is up the offer
       is either covered (mobile) or fighting it for attention (desktop), and a
       close tap through the one reachable control would snooze for 30 days. */
    var opened = false;
    var poll = null;
    function openWhenClear() {
      if (opened) return;
      if (!consentBannerVisible()) { opened = true; if (poll) clearInterval(poll); openBox(); return; }
      if (poll) return;
      var tries = 0;
      poll = setInterval(function () {
        tries++;
        if (!consentBannerVisible()) { opened = true; clearInterval(poll); poll = null; openBox(); }
        else if (tries > 1500) { clearInterval(poll); poll = null; }
      }, 400);
      document.addEventListener('visitorConsentCollected', function () {
        setTimeout(openWhenClear, 350);
      }, { once: true });
    }

    var armed = false;
    function arm() { if (armed) return; armed = true; openWhenClear(); }
    setTimeout(arm, SHOW_AFTER_MS);
    window.addEventListener('scroll', function onScroll() {
      var sc = (window.scrollY || 0) / Math.max(1, (document.body.scrollHeight - window.innerHeight));
      if (sc >= SHOW_AFTER_SCROLL) { arm(); window.removeEventListener('scroll', onScroll); }
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      if (!armed && e.clientY <= 0 && window.innerWidth > 600) arm();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
